export default "__VITE_ASSET__tvj5ed____"